export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11903.c34730a5.jpg";